<template>
  <v-card class="elevation-1 mb-6 rounded-lg mt-0">
    <v-card-title class="pa-7">
      Komentáře
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        height="40px"
        min-width="130px"
        depressed
        @click.prevent="openAddCommentDialog()"
        >Nový komentář</v-btn
      >
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="orderHeadersByRole"
        :items="comment.items"
        :options.sync="comment.options"
        :server-items-length="comment.serverItemsLength"
        :loading="comment.loading"
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:item.content="{ item }">
          <div style="max-width: 300px; padding-top: 5px; padding-bottom: 5px">
            {{ item.content }}
          </div>
        </template>
        <template v-slot:item.createdAt="{ item }">
          <DateTime :single-line="false" :datetime="item.createdAt" />
        </template>
      </v-data-table>
    </v-card-text>
    <OrderCommentAddDialog @commentAdded="commentAdded" />
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '@/components/DateTime'
import OrderCommentAddDialog from '@/components/order/OrderCommentAddDialog'

export default {
  name: 'OrderComments',
  components: {
    OrderCommentAddDialog,
    DateTime,
  },
  mixins: [setFilters],
  props: {
    id: {
      id: Number,
      required: true,
    },
  },
  data() {
    return {
      comment: {
        headers: [
          {
            text: 'Datum',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Uživatel',
            value: 'createdBy',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
          {
            text: 'Komentář',
            value: 'content',
            roles: ['ROLE_ADMIN'],
            sortable: false,
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 5,
          sortBy: ['id'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      commentFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    orderHeadersByRole() {
      return this.comment.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    status: {
      handler() {
        this.loadComments()
      },
    },
    'comment.options': {
      handler() {
        this.loadComments()
      },
    },
    '$route.query': {
      handler() {
        this.loadComments()
      },
    },
  },
  methods: {
    ...mapActions({
      searchOrderComments: 'order/searchOrderComments',
    }),
    loadComments() {
      this.comment.loading = true
      const searchParams = {
        options: this.comment.options,
      }
      this.searchOrderComments({ id: this.id, params: searchParams })
        .then((response) => {
          this.commentFooter.totalElements = response.data.totalElements
          this.comment.items = response.data.items
          this.comment.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.comment.loading = false
        })
    },
    openAddCommentDialog() {
      this.$eventBus.$emit('addCommentDialog', true)
    },
    commentAdded() {
      this.loadComments()
    },
    setFiltersAction(filters) {
      this.comment.options.page = 1
      this.setFilters(filters)
    },
  },
}
</script>
